const DEFAULT_INACTIVITY_TIMEOUT = 180;
const EXCLUDED_PRODUCT_LINES = ['Foremost Choice', 'Bristol West'];

const COLLATERAL_MARKETING_CONTACT_EMAIL = process.env.COLLATERAL_MARKETING_CONTACT_EMAIL || '';

export {
    DEFAULT_INACTIVITY_TIMEOUT,
    EXCLUDED_PRODUCT_LINES,
    COLLATERAL_MARKETING_CONTACT_EMAIL,
};
